import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAccessToken } from './tokenStore';

/**
 * OAuth callback handler — auth-service redirects here with
 *   /auth/callback#access_token=...&expires_in=...
 * The refresh cookie is already set HttpOnly. We move the access token into memory.
 */
export function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const access = hash.get('access_token');
    const ttl = Number(hash.get('expires_in') ?? '600');
    if (access) {
      setAccessToken(access, ttl);
      window.history.replaceState(null, '', '/');
      navigate('/', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [navigate]);
  return <p className="p-8">Signing you in…</p>;
}
